import * as jsxRuntime from "/srv/gitlab-runner/builds/X8tl-siUs/0/lya-protect/muta/lya-protect-muta-form/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment